<template>
    <create-new-button
        v-if="addButton"
        :btn-text="buttonText"
        :events="activator"
        :has-border="hasBorder"
        :disabled="disabled"
        background
        @create-new="$emit('click')"
    />
    <icon-button
        v-else-if="editButton"
        :events="activator"
        :ignore-parent-read-only="ignoreParentReadonly"
        :disabled="disabled"
        icon="custom:edit"
        @click.stop="$emit('click')"
    />
    <delete-button-comp
        v-else-if="deleteButton"
        :events="activator"
        :data-id-e2e="deleteButtonId"
        :ignore-parent-read-only="ignoreParentReadonly"
        :disabled="disabled"
        background
        @delete="fetchChildDependencies"
    />
</template>

<script setup>
import { camelCase } from 'lodash';
import resources from '@enums/resources';
import { unref } from 'vue';
import { useStore } from 'vuex';
// aliased: tag name must not match the deleteButton prop, or <script setup> resolves the tag to the prop's value instead of the component
import deleteButtonComp from './buttons/delete-button.vue';

const { campaigns, subCampaigns, scenarios } = unref(resources);

const props = defineProps({
    activator: Object,
    buttonText: String,
    hasBorder: Boolean,
    addButton: Boolean,
    editButton: Boolean,
    ignoreParentReadonly: {
        type: Boolean,
        default: null,
    },
    deleteButton: Boolean,
    resourceId: String,
    resource: String,
    deleteButtonId: {
        type: String,
        default: 'deleteButton',
    },
    disabled: Boolean,
});
defineEmits(['click']);

const store = useStore();

const fetchChildDependencies = async () => {
    if ([campaigns, camelCase(subCampaigns), scenarios].includes(props.resource)) {
        await store.dispatch(`${props.resource}/fetchChildDependencies`, {
            id: props.resourceId,
            includeGhosts: true,
        });
    }
};
</script>
